/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {
  getResellerName,
  isReseller
} from './Resellers';

/**
 * Defines the {@link useReseller} hook returns types which are simply
 * wrappers around the {@link getResellerName} and {@link isReseller}
 * APIs.
 *
 * @param reseller {@link getResellerName}
 * @param isReseller {@link isReseller}
 * @param getTranslation {@link getTranslation}
 */
export type UseResellerResult = {
  reseller: string | undefined,
  isReseller: boolean
}

/**
 * Provides a hook which returns information about the CalAmp Co-Branded
 * Customer reseller. This hook is intended to be used directly by components
 * in place of the {@link isReseller} and {@link getResellerName} APIs.
 *
 * ```typescript
 *   import {useReseller} from '@ion/dls/src/theme/resellers';
 *   ...
 *   const {isReseller, reseller} = useReseller();
 * ```
 *
 * @see {@link isReseller} API.
 * @see {@link getResellerName} API.
 */
const useReseller = (): UseResellerResult => {
  return {
    isReseller : isReseller(),
    reseller   : getResellerName()
  };
};
export default useReseller;
